import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { getAuthCode, isProduction } from '../../lib/utils';
import segImage from '../../images/img_aseguro.png';
import FormGroup from '../../components/FormGroup';
import { Button } from '../../components/Button';
import { Title } from '../../components/Title';
import { device, rem } from '../../lib/global-styles';

const SimulatorWrapper = styled.div`
  padding: ${rem(15)};

  @media ${device.desktop} {
    padding-top: ${rem(20)};
    width: ${rem(890)};
    margin: auto;

    div {
      padding: 0;
    }
  }
`;

class Simulator extends Component {
  state = {
    // subscriber: '54545454545',
    subscriber: '169674164',
    nextRecharge: '2018-05-25',
    // document: '6325656',
    document: '86329152803',
    channel: 'site',
    code: null,
  };

  onInputChange = e => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
  };

  onClickSubmit = e => {
    e.preventDefault();

    getAuthCode(this.state)
      .then(data => {
        this.setState({ code: data });
      })
      .catch(err => {
        console.error('Error during authentication:', err);
      });
  };

  render() {
    const { subscriber, nextRecharge, document, code, channel } = this.state;

    if (code) {
      return <Redirect to={`/?code=${code}`} />;
    }

    if (isProduction()) {
      return null;
    } else {
      return (
        <SimulatorWrapper>
          <Title>SIMULADOR</Title>
          <FormGroup
            type="tel"
            id="assinante"
            label="Assinante"
            placeholder="Assinante"
            value={subscriber}
            name="subscriber"
            onChangeValue={this.onInputChange}
          />
          <FormGroup
            type="date"
            id="proximarecarga"
            label="Proxima Recarga"
            placeholder="Proxima Recarga"
            value={nextRecharge}
            name="nextRecharge"
            onChangeValue={this.onInputChange}
          />
          <FormGroup
            type="tel"
            id="documento"
            label="Documento"
            placeholder="Documento"
            value={document}
            name="document"
            onChangeValue={this.onInputChange}
          />
          <FormGroup
            type="tel"
            id="canal"
            label="canal (appminhasky ou site)"
            placeholder="canal (appminhasky ou site)"
            value={channel}
            name="channel"
            onChangeValue={this.onInputChange}
          />
          <Button onClick={this.onClickSubmit} type="submit" theme={{ style: 'dark' }}>
            ENVIAR
          </Button>
          <Title>
            <img src={segImage} alt="Ambiente Seguro" />
          </Title>
        </SimulatorWrapper>
      );
    }
  }
}

export default connect()(Simulator);
